// extracted by mini-css-extract-plugin
export default {"container":"lBG3P77EJAW8q2RKddyO"};